export const signalsDateFormat = "MM/dd - HH:mm"
export const ordersDateFormat = "MM/dd - HH:mm"
export const TZ = "America/New_York"
export const RESPONSIVE_TABLE_BREAKPOINT = 768;